import * as yup from 'yup'

export const ForgotPasswordValidationScheme = yup.object().shape({
  email: yup.string().email('Email Address is invalid').max(100).required('The field is required')
})
